// Generated by purs version 0.15.16
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Variant from "../Data.Variant/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Record from "../Record/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var match = /* #__PURE__ */ Data_Variant.match()()();
var authorIsSymbol = {
    reflectSymbol: function () {
        return "author";
    }
};
var map1 = /* #__PURE__ */ Data_Functor.map(GraphQL_Query.queryFunctor);
var rltvCons = /* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil);
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var rntyType = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
});
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var rltvCons1 = /* #__PURE__ */ rltvCons(idIsSymbol)(rntyType)(encRNTY)()();
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var rntyType1 = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "CommentInput";
    }
});
var publicIsSymbol = {
    reflectSymbol: function () {
        return "public";
    }
};
var commentIsSymbol = {
    reflectSymbol: function () {
        return "comment";
    }
};
var encRNTY1 = /* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(publicIsSymbol)())(commentIsSymbol)())());
var rltvfConsOther = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil);
var rltvfConsOther1 = /* #__PURE__ */ rltvfConsOther(idIsSymbol)();
var rltvfConsOther2 = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther(publicIsSymbol)())(commentIsSymbol)();
var TeacherIsSymbol = {
    reflectSymbol: function () {
        return "Teacher";
    }
};
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(nameIsSymbol)()())();
var StudentIsSymbol = {
    reflectSymbol: function () {
        return "Student";
    }
};
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Internal_Luxon.decodeLDT));
var updated_atIsSymbol = {
    reflectSymbol: function () {
        return "updated_at";
    }
};
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var recShape = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()())();
var jsonQR = /* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Shape.unionDecode(/* #__PURE__ */ GraphQL_Shape.unDecCons(/* #__PURE__ */ GraphQL_Shape.unDecCons(GraphQL_Shape.unDecNil)(TeacherIsSymbol)(decodeRecord)()())(StudentIsSymbol)(decodeRecord)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil)(updateIsSymbol)()())(deleteIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil)(updated_atIsSymbol)()())(publicIsSymbol)()())(idIsSymbol)()())(created_atIsSymbol)()())(commentIsSymbol)()())(canIsSymbol)()())(authorIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updated_atIsSymbol)(GraphQL_Shape.scalarShape)()())(publicIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(created_atIsSymbol)(GraphQL_Shape.scalarShape)()())(commentIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updateIsSymbol)(GraphQL_Shape.scalarShape)()())(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(authorIsSymbol)(/* #__PURE__ */ GraphQL_Shape.unionShape(/* #__PURE__ */ GraphQL_Shape.varhsCons(/* #__PURE__ */ GraphQL_Shape.varhsCons(GraphQL_Shape.varhsNil)(TeacherIsSymbol)(recShape)()())(StudentIsSymbol)(recShape)()())())()())());
var buildMutation = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(rltvCons1)(dataIsSymbol)(rntyType1)(encRNTY1)()())(/* #__PURE__ */ GraphQL_Query.rltvfNamedTypeRec(rltvfConsOther1)(dataIsSymbol)()()(rltvfConsOther2))())(jsonQR);
var parent_typeIsSymbol = {
    reflectSymbol: function () {
        return "parent_type";
    }
};
var parent_idIsSymbol = {
    reflectSymbol: function () {
        return "parent_id";
    }
};
var buildMutation1 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons(parent_typeIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "CommentParentType";
    }
}))(encRNTY)()())(parent_idIsSymbol)(rntyType)(encRNTY)()())(dataIsSymbol)(rntyType1)(encRNTY1)()())(/* #__PURE__ */ GraphQL_Query.rltvfNamedTypeRec(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther(parent_typeIsSymbol)())(parent_idIsSymbol)())(dataIsSymbol)()()(rltvfConsOther2))())(jsonQR);
var buildMutation2 = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(rltvCons1)(rltvfConsOther1)())(jsonQR);
var FormComment = /* #__PURE__ */ (function () {
    function FormComment(value0) {
        this.value0 = value0;
    };
    FormComment.create = function (value0) {
        return new FormComment(value0);
    };
    return FormComment;
})();
var processComment = /* #__PURE__ */ (function () {
    var processAuthor = function (au) {
        return Data_Maybe.fromMaybe({
            name: "No Author"
        })(map(match({
            Student: function (s) {
                return {
                    name: s.name
                };
            },
            Teacher: function (s) {
                return {
                    name: s.name
                };
            }
        }))(GraphQL_Shape.fromUnion(au)));
    };
    return Record.modify(authorIsSymbol)()()(Type_Proxy["Proxy"].value)(processAuthor);
})();
var updateComment = function (id) {
    return function (input) {
        return map1(processComment)(buildMutation("updateComment")({
            id: id,
            data: GraphQL_Type.namedType(input)
        }));
    };
};
var postComment = function (parent) {
    return function (input) {
        var parent$prime = {
            id: parent.value0,
            type: GraphQL_Type.namedType("FORM")
        };
        return map1(processComment)(buildMutation1("createComment")({
            parent_id: parent$prime.id,
            parent_type: parent$prime.type,
            data: GraphQL_Type.namedType(input)
        }));
    };
};
var deleteComment = function (id) {
    return map1(processComment)(buildMutation2("deleteComment")({
        id: id
    }));
};
export {
    processComment,
    FormComment,
    postComment,
    updateComment,
    deleteComment
};
//# sourceMappingURL=index.js.map
